import React from "react";
import TextAdventure from "./components/TextAdventure";

function App() {
  return <TextAdventure />;
}

export default App;
